module.exports = __webpack_public_path__ + "static/img/etc_01_btn.4946fab.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/etc_01_btn.jpg
// module id = ceV8
// module chunks = 1